import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getAuthPharmacyId,
  getIntercomUnreadCount,
  getIsAuthenticated,
  getUserAssignedPharmacyId,
} from '../../redux/modules/root-reducer';
import PageContainer from '../../components/PageContainer';
import serverPaths from '../../../server/routes/paths';

const helpButtonTitle = count => {
  if (!count) return 'Help';
  const messages = count === 1 ? 'message' : 'messages';
  return `Help · ${count} unread ${messages}`;
};

const getLinkData = (state, props) => {
  const loggedInLinks = getIsAuthenticated(state) ? [
    {
      href: `/actions/${serverPaths.actions.logout}`,
      text: 'Sign out',
      verb: 'POST',
      onClick: (e) => {
        const confirm = global.confirm('Log out?');
        if (!confirm) e.preventDefault();
      },
    },
  ] : [];
  const loggedOutLinks = props && props.hideHelp ? [] : [
    {
      id: '',
      href: `#`,
      text: helpButtonTitle(getIntercomUnreadCount(state)),
      cssClass: 'intercom_launch',
    },
  ];
  const links = [...loggedOutLinks, ...loggedInLinks];
  if (props && props.customLinks) {
    props.customLinks.forEach((link) => links.splice((link.position || 0), 0, link));
  }
  return links;
};

export const mapStateToProps = (state, props) => ({
  topBarLinks: getLinkData(state, props),
  pharmacy: getUserAssignedPharmacyId(state) || getAuthPharmacyId(state),
});

const ConnectedContainer = connect(
  mapStateToProps,
  null,
)(PageContainer);

/**
 * Wrapper returns the PageContainer when the store is not set,
 * or a connected page container with intercom integration.
 */
const Wrapper = (props, context) => {
  const { store } = context;
  if (!store) return <PageContainer {...props} />;
  return <ConnectedContainer {...props} />;
};
Wrapper.contextTypes = { store: PropTypes.object };

export default Wrapper;
